import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LoopBackAuth, PartnerApi, UserDataApi } from '@assets/js/lb-sdk';
import { LoadingAndErrors } from '@app/classes';
import { finalize } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap';
import { ChangeUsernameComponent } from '../change-username/change-username.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { ToastrService } from 'ngx-toastr';
import { HasRolePipe } from '@app/pipes/has-role.pipe';
import { USER_ROLES } from '@app/enums';
import { environment } from '@environments/environment';

import 'webcomponent-qr-code';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends LoadingAndErrors implements OnInit {
  merchantDetails;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;

  value: string = '';
  valueDisplay: string = '';
  constructor(
    private loopBackAuth: LoopBackAuth,
    private userDataApi: UserDataApi,
    private ModalService: BsModalService,
    private toast: ToastrService,
    private hasRole: HasRolePipe
  ) {
    super();
  }

  ngOnInit() {
    if (this.hasRole.transform(this.getUser().roles, USER_ROLES.GENERAL_MERCHANT, '>=')) {
      this.getMerchantDetails();
    }
    let baseUrl = 'https://stormlearning4.myshopify.com/';
    if (environment.production) {
      baseUrl = 'https://shop.maxicare.com.ph/';
    }
    this.value = this.formatDeepLink(baseUrl,this.getUser().username);
    this.valueDisplay = this.formatDeepLink(baseUrl,this.getUser().username);
  }

  copyQR() {
    const qrCode = document.querySelector('qrcode');
    const base64 = qrCode.children[1].getAttribute('src');
    const blob = this.convertBase64ToBlob(base64);
    return navigator['clipboard'].write([new ClipboardItem({ [blob.type]:blob})])
  }

  // Only used if you plan to download the img
  convertBase64ToBlob(Base64Image: string) {
    const parts = Base64Image.split(";base64,")
    const imageType = parts[0].split(":")[1]
    const decodedData = atob(parts[1])
    const uInt8Array = new Uint8Array(decodedData.length)
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i)
    }
    return new Blob([uInt8Array], { type: imageType })
  }

  copyLink() {
    return navigator['clipboard'].writeText(this.value);
  }

  formatDeepLink(base: string,username: string) {
    let encoded = btoa(username);
    return base + '?maxi-link=' +  encoded;
  }

  getMerchantDetails() {
    this.loading.list = true;
    this.clearErrors();
    this.userDataApi
      .getUserMerchantDetails()
      .pipe(finalize(
        () => {
          this.loading.list = false;
        }
      ))
      .subscribe(
        details => {
          this.merchantDetails = details;
        },
        error => {
          this.errors.list = error.message || 'Unable to get Merchant Details';
        }
      );
  }

  changeUsername() {
    const changeUserNameModal = this.ModalService
      .show(ChangeUsernameComponent, {
        initialState: {
          data: { username: this.getUser().username }
        }
      });
    const subscription = this.ModalService.onHidden
      .subscribe(() => {
        if (changeUserNameModal.content) {
          if (changeUserNameModal.content.result) {
            this.toast.success('Successfully updated username!', 'Update Success');
          }
        }
        subscription.unsubscribe();
      });
  }

  changePassword() {
    const changePasswordModal = this.ModalService
      .show(ChangePasswordComponent, {
        initialState: {
          requireCurrentPassword: true
        }
      });
    const subscription = this.ModalService.onHidden
      .subscribe(() => {
        if (changePasswordModal.content) {
          if (changePasswordModal.content.result) {
            this.toast.success('Successfully updated password!', 'Update Success');
          }
        }
        subscription.unsubscribe();
      });
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

}
